import { internalColors } from '@acsbe/themes';
import {
  Banner,
  Content,
  Flex,
  NeoModal,
  useCloseCurrentModal,
  usePlatformProps,
  type LeanModalProps,
} from '@acsbe/ui';
import { useEffect, type FunctionComponent } from 'react';
import { Trans, useTranslation } from 'react-i18next';
import ReactPlayer from 'react-player';

import LEARN_FEATURE_ANIMATION from './learnFeatureAnimation.mp4';

const LEARN_FEATURE_DIALOG_KEY_PREFIX =
  'INSTALLATION_PAGE.LEARN_FEATURE_DIALOG';

export const LearnFeatureModal: FunctionComponent<LeanModalProps> = (props) => {
  const { t } = useTranslation();
  const close = useCloseCurrentModal();
  const p = usePlatformProps();

  useEffect(() => {
    const element = window.document.body;
    element.classList.add('remove-blur-background');
    return () => element.classList.remove('remove-blur-background');
  });

  return (
    <NeoModal
      {...props}
      closeButtonProps={{
        'data-mixpanel': 'close-learn-feature-modal',
      }}
      closeLabel={t('CLOSE')}
      onClose={close}
      open
      size="md"
      title={t(`${LEARN_FEATURE_DIALOG_KEY_PREFIX}.TITLE`)}
    >
      <NeoModal.Body>
        <Flex gap={6} {...p.uptoTablet({ gap: 4 })}>
          <ReactPlayer
            loop
            playing
            src={LEARN_FEATURE_ANIMATION}
            style={{ height: '300px', width: '100%', borderRadius: '8px' }}
          />
          <Flex>
            <Content lineHeight={1.5}>
              {t(`${LEARN_FEATURE_DIALOG_KEY_PREFIX}.STEP_1`)}
            </Content>
            <Content lineHeight={1.5}>
              {t(`${LEARN_FEATURE_DIALOG_KEY_PREFIX}.STEP_2`)}
            </Content>
            <Content lineHeight={1.5}>
              {t(`${LEARN_FEATURE_DIALOG_KEY_PREFIX}.STEP_3`)}
            </Content>
          </Flex>

          <Banner
            backgroundColor={internalColors.grays[100]}
            cta={null}
            description={
              <Trans
                components={[<Content emphasis="low" inline />]}
                i18nKey="INSTALLATION_PAGE.LEARN_FEATURE_DIALOG.BANNER_DESCRIPTION"
              />
            }
            textColor={internalColors.grays[900]}
          />
        </Flex>
      </NeoModal.Body>

      <NeoModal.Footer
        positiveCta={{
          onClick: close,
          children: 'Continue',
          'data-mixpanel': 'continue-learn-feature-modal',
          variant: 'primary',
        }}
      />
    </NeoModal>
  );
};
